import { apiCall } from "../../../_utils";
import { apiUrls } from "../../../_constants";

export const configService = {
  getAllConfigs,
  addConfig,
  getConfig
};

function getAllConfigs() {
  return apiCall("GET", apiUrls.configs.base);
}

function addConfig(request) {
  const method = request && request.id ? "PUT" : "POST";
  return apiCall(method, apiUrls.configs.base, request);
}

function getConfig(id) {
  return apiCall("GET", `${apiUrls.configs.base}/${id}`);
}
